// import path from 'path';

import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

// import { devLogger } from '@utils/logger';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)

i18next
	.use(Backend)
	.use(initReactI18next) // passes i18n down to react-i18next
	.init({
		fallbackLng: 'en',
		// debug: process.env.NODE_ENV !== 'production',
		ns: ['common'],
		fallbackNS: ['common'],
		backend: {
			// for all available options read the backend's repository readme file
			loadPath: `${
				process.env.NODE_ENV === 'production'
					? 'https://bitbns.com'
					: `http://localhost:3000`
			}/locales/{{lng}}/{{ns}}.json`,
			allowMultiLoading: true,
		},
		supportedLngs: ['en', 'tr'],
		preload: ['en', 'tr'],
		lng: 'tr', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
		// you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
		// if you're using a language detector, do not define the lng option

		interpolation: {
			escapeValue: false, // react already safes from xss
		},
		react: {
			useSuspense: false,
		},
	})
	.catch(res => {
		console.log('i18next', res, 'fail');
	});

export { i18next };
